/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

/**
 * Типове файлове които могат да се качват в Media Library
 */
export enum MediaLibraryAcceptTypes {
  PDF = '*.pdf',
  IMAGES = '.jpg,.jpeg,.png',
  DOC = '.doc,.docx',
  EXCEL = '.xlsx,.xlsm,.xlsb,.xltx,.xltm,.xls,.xlt,.xls',
  ALL = '',
}
